module.exports = __webpack_public_path__ + "static/img/s202.7ccc3bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s202.png
// module id = 544
// module chunks = 3